import { render, staticRenderFns } from "./PageIndexElastic.vue?vue&type=template&id=010db4ae&"
import script from "./PageIndexElastic.vue?vue&type=script&lang=ts&"
export * from "./PageIndexElastic.vue?vue&type=script&lang=ts&"
import style0 from "./PageIndexElastic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports